import React from "react";
import StatusIndicator from "./status";
import { Button, CopyValue } from "../../..";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { getFlightApprovalSearchUrl, isFlightApprovalReadyToBook } from "Utils/flightApproval";
import { StampToDate } from "../../../../Utils/utils";

function FlightBookingStatus({ booking = {} }) {
	const NAVIGATE = useNavigate();
	const { id, date, status, approvalRequest, adminRequest } = booking;
	const showBookNow = isFlightApprovalReadyToBook(booking);
	const searchUrl = getFlightApprovalSearchUrl(booking);

	return (
		<div className="p-2 border-t flex-center-between bg-whitish">
			{showBookNow && searchUrl ? (
				<Button onClick={() => NAVIGATE(searchUrl)} variant="primary" className="btn-xs">
					Book Now <FiArrowRight className="ml-1" />
				</Button>
			) : (
				<div className="min-w-0 flex items-center gap-3">
					<CopyValue className="text-xxs whitespace-nowrap">
						{approvalRequest ? "AIR/APP" : adminRequest ? "AIR/REQ" : "AIR"}-{id}
					</CopyValue>
					{date && (
						<div className="min-w-0 flex items-center gap-1 text-[10px] leading-4 text-secondary">
							<span className="font-medium">Booking Date</span>
							<span className="text-muted">:</span>
							<span>{StampToDate(date)}</span>
						</div>
					)}
				</div>
			)}
			<StatusIndicator status={status} />
		</div>
	);
}

export default FlightBookingStatus;
